// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"51825cf0","455":"e9ddce85","977":"a8a31d60"}[chunkId] + ".chunk.js";
};